import { FC, useMemo } from 'react';
import parse from 'html-react-parser';

import documentTypes from 'constants/documentTypes';
import { useTranslate } from 'hooks/useTranslate';
import useGetDocumentData from 'modules/administratives/pages/CouncilDetails/hooks/useGetDocumentData';
import { ContentTypes } from 'modules/administratives/pages/CouncilMembers/components/CouncilMembersDocumentsCard';
import TemplateViewerBody from 'modules/_shared/components/Modals/TemplateViewer/components/TemplateViewerBody';
import type { Document } from 'types/Document';
import CustomLoading from 'modules/_shared/components/CustomLoading';

type IncentivesMarketTermsByTemplateProps = {
  templateId: string;
};

const IncentivesMarketTermsByTemplate: FC<IncentivesMarketTermsByTemplateProps> = ({
  templateId,
}) => {
  const { t } = useTranslate();

  const { data, isLoading, isError } = useGetDocumentData({
    documentId: templateId,
    templateId: null,
  });

  const htmlContent = useMemo(() => {
    const raw = data.htmlContent;
    if (typeof raw !== 'string') return '';
    return raw.trim();
  }, [data.htmlContent]);

  const isTemplatesCategory = useMemo(
    () => data.document?.category === documentTypes.TEMPLATES,
    [data.document?.category]
  );

  const wrongDocumentCategory =
    !isLoading &&
    !isError &&
    Boolean(data.document?._id) &&
    !isTemplatesCategory;

  const previewTemplate = useMemo((): Document | null => {
    if (!data.document?._id || !htmlContent) return null;
    return {
      ...data.document,
      editorModel: parse(htmlContent),
    } as Document;
  }, [data.document, htmlContent]);

  const showTemplate =
    !isLoading && !isError && isTemplatesCategory && previewTemplate !== null;

  return (
    <div className="card card-bordered">
      <div className="card-inner p-4 p-md-5">
        {isLoading && <CustomLoading />}

        {!isLoading && isError && (
          <p className="text-soft mb-0">{t('Error')}</p>
        )}

        {!isLoading && !isError && wrongDocumentCategory && (
          <p className="text-soft mb-0">{t('Error')}</p>
        )}

        {!isLoading && !isError && showTemplate && previewTemplate && (
          <div
            className="avoid-default-font"
            style={{ maxHeight: '70vh', overflow: 'auto' }}
          >
            <TemplateViewerBody
              template={previewTemplate}
              contentType={ContentTypes.TEMPLATE}
              isEmbedded
            />
          </div>
        )}

        {!isLoading && !isError && isTemplatesCategory && !htmlContent && (
          <p className="text-soft mb-0">{t('Error')}</p>
        )}

        {!isLoading &&
          !isError &&
          !showTemplate &&
          !wrongDocumentCategory &&
          !(isTemplatesCategory && !htmlContent) && (
            <p className="text-soft mb-0">{t('Error')}</p>
          )}
      </div>
    </div>
  );
};

export default IncentivesMarketTermsByTemplate;
